import { noNewOrReviewCommentsExists } from "../helpers/noNewOrReviewCommentsExists";

export const getPostmortemState = (
  changeStatus,
  currState,
  postmortemState,
  thisIsMimIncident
) => {
  switch (currState) {
    case "DRAFT":
      return 0;

    case "LEADERSHIP_REVIEW":
      if (noNewOrReviewCommentsExists(postmortemState)) {
        return 3;
      } else {
        return 3;
      }

    case "DONE":
      return 7;

    default:
      break;
  }
};
